import { Component, OnInit,AfterViewInit,ElementRef,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {commonService} from "../../service/common.service";
declare var $: any;

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
  providers:[]
})
export class LandingComponent implements OnInit,AfterViewInit {

    @ViewChild('leftgeardiv', {read: ElementRef}) leftgeardiv: ElementRef;
    userData:any;


    
    constructor(private commonService:commonService) { 
    this.userData=this.commonService.user;
    
  }

  ngOnInit() {
    //console.log('LandingComponent');
      
  }

  ngAfterViewInit() {
      /*var leftgeardivEle=$(this.leftgeardiv.nativeElement);
        $(window).scroll(function() {
            var theta = $(window).scrollTop() / 300 % Math.PI;  
            leftgeardivEle.css({ transform: 'rotate(' + theta + 'rad)' });   
        });*/
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/landing/landing.component.ts